<!--
  同人周邊DojinPeripheral.vue
-->
<template>
  <div>
    <el-collapse-item title="同人周边" name="同人周边" style="border-bottom: 1.5px solid #CDCDCD; ">
      <el-row type="flex" class="row-bg" justify="space-around" style="border-top: 1px solid #CDCDCD;">
        <el-col :span="24" class="my-middle" style="margin-top: 20px;">
          <h2>同人周邊</h2>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="24" class="my-middle">
          <el-checkbox
            v-bind:key="select.id"
            v-for="select in dojinPeripheral"
            v-model="select.status"
            v-bind:label="select.name"
            style="width:150px;margin:10px"
            border
          ></el-checkbox>
        </el-col>
      </el-row>
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="24">
          <el-collapse v-model="forcollapse" wtfname="dojinPeripheralFormActive">
            <!--内容区域-->
            <Pendant v-if="dojinPeripheral[0].status"/>
            <Plate v-if="dojinPeripheral[1].status"/>
            <Postcard v-if="dojinPeripheral[2].status"/>
            <Poster v-if="dojinPeripheral[3].status"/>
            <Badge v-if="dojinPeripheral[4].status"/>
            <Colorepaper v-if="dojinPeripheral[5].status"/>
            <Sticker v-if="dojinPeripheral[6].status"/>
            <Different v-if="dojinPeripheral[7].status"/>
            <Folder v-if="dojinPeripheral[8].status"/>
            <Another v-if="dojinPeripheral[9].status"/>
          </el-collapse>
        </el-col>
      </el-row>
    </el-collapse-item>
  </div>
</template>

<script>
import Pendant from "./DojinPeripheral/Pendant.vue";
import Plate from "./DojinPeripheral/Plate.vue";
import Postcard from "./DojinPeripheral/Postcard.vue";
import Poster from "./DojinPeripheral/Poster.vue";
import Badge from "./DojinPeripheral/Badge.vue";
import Colorepaper from "./DojinPeripheral/Colorepaper.vue";
import Sticker from "./DojinPeripheral/Sticker.vue";
import Different from "./DojinPeripheral/Different.vue";
import Folder from "./DojinPeripheral/Folder.vue";
import Another from "./DojinPeripheral/Another.vue"
export default {
  name: "DojinPeripheral", //同人周邊
  components: {
    Pendant,
    Plate,
    Postcard,
    Poster,
    Badge,
    Colorepaper,
    Sticker,
    Different,
    Folder,
    Another
  },
  data() {
    return {
      forcollapse: ['挂件','立牌','明信片','海报','徽章','色纸','贴纸','异形制品','文件夹','其他'],
      dojinPeripheral: [
        { id: "Pendant", name: "挂件", status: false },
        { id: "Plate", name: "立牌", status: false },
        { id: "Postcard", name: "明信片", status: false },
        { id: "Poster", name: "海报", status: false },
        { id: "Badge", name: "徽章", status: false },
        { id: "Colorepaper", name: "色纸", status: false },
        { id: "Sticker", name: "贴纸", status: false },
        { id: "Different", name: "异形制品", status: false },
        { id: "Folder", name: "文件夹", status: false },
        { id: "Another", name: "其他", status: false }
      ],
      dojinPeripheralFormActive: ["挂件"]
    };
  }
};
</script>

<style scoped>
</style>